import script from "./HighRecommended.vue?vue&type=script&setup=true&lang=js"
export * from "./HighRecommended.vue?vue&type=script&setup=true&lang=js"

import "./HighRecommended.vue?vue&type=style&index=0&id=1685f85c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1685f85c"]])

export default __exports__